<script>
import { useRoute } from 'vue-router';
const route = useRoute();
export default {
  name: 'PolicyItemResult',
  props: {
    policy: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div class="policy_item">
    <NuxtLink
      :to="policy.url">
      <div class="flex-1  flex-col justify-start items-start gap-1">
        <div class="inline-flex justify-start items-baseline gap-2">
          <font-awesome :icon="['far', 'book']" size="xs" class="policy-result-icon" />
          <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{
              policy.book
            }}</div>
          <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
          <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ policy.section }}</div>
          <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
          <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ policy.title }}</div>
        </div>
        <div class="self-stretch justify-center highlight">...<span v-html="policy.search_highlight"></span>...</div>
      </div>
    </NuxtLink>

    <div v-if="policy.attachment_matches && policy.attachment_matches.length" class="mt-2">
      <a
        v-for="match in policy.attachment_matches"
        :key="match.id"
        :href="match.url"
        target="_blank"
        class="block pl-6 mt-2"
      >
        <div class="flex-1 flex-col justify-start items-start gap-1">
          <div class="inline-flex justify-start items-baseline gap-2 flex-wrap">
            <font-awesome :icon="['far', 'file-pdf']" size="xs" class="document-result-icon" />
            <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ policy.book }}</div>
            <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
            <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ policy.section }}</div>
            <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
            <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ policy.title }}</div>
            <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
            <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ match.title }}</div>
          </div>
          <div v-if="match.context" class="self-stretch justify-center highlight"><span v-html="match.context"></span></div>
        </div>
      </a>
    </div>
  </div>
</template>

<style>
  .policy_item {
    margin-bottom: 32px;
  }
  .highlight {
    color: #64748b; /* text-slate-500 */
    font-size: 0.875rem; /* text-sm (14px) */
    font-weight: 400; /* font-normal */
    font-family: 'Söhne', sans-serif; /* font-['Söhne'] */
    line-height: 1.25; /* leading-tight */
    background-color: unset;
  }

  mark {
    background-color: unset;
    font-weight: 500;
  }

  .policy-result-icon {
    color: #3658C8
  }

  .document-result-icon {
    color: #6366F1;
  }
</style>
